module.exports = __webpack_public_path__ + "static/img/icon_toolkit.6ab788f2.svg";